var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.852,
    height: 25.725,
    className: "magnifying-glass",
    viewBox: "0 0 24.852 25.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".magnifying-glass .a{fill:#4ebcfa;stroke:#4ebcfa;stroke-width:0.8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.4 0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.9,15.76H17.532V13.394a.394.394,0,0,0-.789,0V15.76H14.377a.394.394,0,0,0,0,.789h2.366v2.366a.394.394,0,0,0,.789,0V16.549H19.9a.394.394,0,1,0,0-.789Z",
    transform: "translate(-7.413 -6.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.852,24.129l-6.993-7.272a9.89,9.89,0,1,0-.7.634l7.009,7.29a.471.471,0,0,0,.679-.652ZM1.924,9.882a8.941,8.941,0,1,1,8.941,8.941A8.951,8.951,0,0,1,1.924,9.882Z",
    transform: "translate(-0.983)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.1fa8f9673aaad1560a01f6b8f00d6ce4.svg";
export { ForwardRef as ReactComponent };